export default __webpack_public_path__ + "static/media/forward-arrow.1148a017.svg";